import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import FaSpinner from 'react-icons/fa/spinner';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl';

interface ILoginFormProps extends InjectedFormProps {
  actions: {
    push: (route: string) => void;
  };
  embed?: boolean;
}

class LoginForm extends React.Component<ILoginFormProps> {
  public static defaultProps: Partial<ILoginFormProps> = {
    embed: false,
  };

  public render() {
    const { handleSubmit, submitting, embed } = this.props;
    const fieldWidth = embed ? 9 : 5;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} method="post" autoComplete="off">
        {embed && (
          <p>
            Nous sommes heureux de vous accueillir à nouveau ! Veuillez vous
            connecter pour enregistrer ce nouveau devis dans votre espace personnel
          </p>
        )}
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Votre adresse électronique
          </Col>
          <Col sm={fieldWidth}>
            <Field
              id="email"
              name="email"
              type="email"
              component={FieldFormControl}
            />
          </Col>
        </FormGroup>
        {/*<FormGroup controlId="name">*/}
          {/*<Col componentClass={ControlLabel} sm={3}>*/}
            {/*Date de naissance*/}
          {/*</Col>*/}
          {/*<Col sm={3}>*/}
            {/*<Field*/}
              {/*name={'dob'}*/}
              {/*type="masked-date"*/}
              {/*component={FieldFormControl}*/}
              {/*placeholder="dd/mm/yyyy"*/}
              {/*className="form-control"*/}
            {/*/>*/}
          {/*</Col>*/}
        {/*</FormGroup>*/}
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Mot de passe
          </Col>
          <Col sm={fieldWidth}>
            <Field
              id="password"
              name="password"
              type="Password"
              component={FieldFormControl}
            />
          </Col>
        </FormGroup>
        <div className={'btn-bar section' + (this.props.embed ? ' embed' : '')}>
          <Link
            disabled={submitting}
            className="btn-secondary red back-btn btn"
            to={'/auth/remind'}
          >
            Réinitialiser le mot de passe
          </Link>

          <Button
            type="submit"
            disabled={submitting}
            className="pull-right btn-secondary red continue-btn"
          >
            {submitting ? (
              <FaSpinner className="fa-spin"/>
            ) : (
              <span>S'identifier</span>
            )}
          </Button>
        </div>
      </Form>
    );
  }
}

export default flow([
  reduxForm({
    form: 'login',
  }),
  connect(null,
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(LoginForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/Login/components/LoginForm/index.tsx